import { render, staticRenderFns } from "./RecentInfiniteListCancelled.vue?vue&type=template&id=022074d6&scoped=true&lang=pug&"
import script from "./RecentInfiniteListCancelled.vue?vue&type=script&lang=js&"
export * from "./RecentInfiniteListCancelled.vue?vue&type=script&lang=js&"
import style0 from "./RecentInfiniteListCancelled.vue?vue&type=style&index=0&id=022074d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022074d6",
  null
  
)

export default component.exports